/**
 * @fileoverview Whether Grow is open inside an app's own browser (Instagram,
 * Facebook, Messenger), where Google refuses its sign-in ("403
 * disallowed_useragent"): a visitor who taps "Continue with Google" there gets
 * an error and leaves. The sign-in page then offers email only, Google's
 * button and One Tap hidden (owner, 2026-10-14, for the Facebook ad test:
 * every ad click opens in Facebook's in-app browser).
 *
 * Told by the browser's user agent: Instagram's says "Instagram", Facebook's
 * "FBAN", "FBAV", "FB_IAB", "FB4A" or "FBIOS", Messenger's "Messenger".
 *
 * Where: LoginPage.
 * API: none.
 *
 * @module inAppBrowser
 */

/** The user agent words of the in-app browsers Google's sign-in refuses. */
const IN_APP_AGENTS = /\b(Instagram|FBAN|FBAV|FB_IAB|FB4A|FBIOS|Messenger)\b/i;

/**
 * Whether this page is open inside Instagram's, Facebook's or Messenger's own browser.
 *
 * @param userAgent - The browser's user agent; the current browser's when not given.
 * @returns True inside one of those apps; false elsewhere, and where there is no browser.
 */
export function inAppBrowser(userAgent: string = typeof navigator === 'undefined' ? '' : navigator.userAgent): boolean {
  return IN_APP_AGENTS.test(userAgent);
}
